import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants'
import Finalization from './finalization'
import Funding from './funding'
import VehiclesList from './vehicles-list'
import VehicleDetail from './vehicle-detail'
import Congratulations from './congratulations'
import TradeIn from './trade-in'

const aSteps = [
  {
    hash: routes.STOCK_VEHICLES_LIST,
    title: <FormattedMessage id="stock-wizard-title-1" />,
    component: <VehiclesList />
  },
  {
    hash: routes.STOCK_VEHICLE_DETAIL,
    title: <FormattedMessage id="stock-wizard-title-1" />,
    component: <VehicleDetail />,
    backButtonText: <FormattedMessage id="stock-wizard-vehicle-detail-backButton" />
  },
  {
    hash: routes.STOCK_CONGRATULATIONS,
    component: <Congratulations />,
    backButtonText: <FormattedMessage id="stock-wizard-congratulations-backButton" />
  },
  {
    hash: routes.STOCK_TRADEIN,
    title: <FormattedMessage id="stock-wizard-title-2" />,
    component: <TradeIn />
  },
  {
    hash: routes.STOCK_FUNDING,
    title: <FormattedMessage id="stock-wizard-title-3" />,
    component: <Funding />,
    backButtonText: <FormattedMessage id="stock-wizard-funding-backButton" />,
    nextButtonText: <FormattedMessage id="stock-wizard-funding-nextButton" />
  },
  {
    hash: routes.STOCK_FINALIZATION,
    title: <FormattedMessage id="stock-wizard-title-4" />,
    component: <Finalization />
  }
]

export default aSteps
